'use client';

import React, { useRef, useState } from 'react';
import styles from './magnify-image.module.scss';
import cx from 'classnames';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';

const MagnifyImage = ({ children, isFallbackImage = false }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [lensPosition, setLensPosition] = useState({ x: 0, y: 0 });
  const [isLensVisible, setIsLensVisible] = useState(false);
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  //To get the height and width of the images
  const  { height = 0 ,width=0 } = containerRef.current?.getBoundingClientRect() || {};
  // we probably need to calulate this original image / lens. Note the value may be differnt for x and y axis
  const lensSize = 140;
   const zoom = width !==0  ? width / 140 : 340 / 140;
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleMouseMove = (e) => {
    const bounds = containerRef.current?.getBoundingClientRect();
    if (!bounds) return;
    //to fix the lens coordinates
    let x = e.clientX - bounds.left - lensSize / 2;
    let y = e.clientY - bounds.top - lensSize / 2;

    x = Math.max(0, Math.min(x, bounds.width - lensSize));
    y = Math.max(0, Math.min(y, bounds.height - lensSize));

    setLensPosition({ x, y });
  };

  const handleMouseLeave = () => {
    clearTimeout(timerRef.current);
    setIsLensVisible(false);
  };
  const handleMouseEnter = () => {
    timerRef.current = setTimeout(() => setIsLensVisible(true), 300);
  };
  const imageSrc = children.props.image?.src
    ? children.props.image?.src
    : children.props.src;
  if (!isLG) {
    return <>{children}</>;
  }
  return (
    <>
      <div
        ref={containerRef}
        className={cx('position-relative', styles['img-zoom-container'])}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onMouseEnter={handleMouseEnter}
      >
        {children}
        {isLensVisible && (
          <div
            className={cx(
              styles['lens'],
              'align-items-center justify-content-center position-absolute',
              { 'd-none': !isLensVisible, 'd-flex': isLensVisible }
            )}
            style={{
              left: `${lensPosition.x}px`,
              top: `${lensPosition.y}px`
            }}
          >
            <CatIconSearch
              color="information"
              className="u-fill--MediumBlue"
              size="lg"
            />
          </div>
        )}
      </div>
      <div
        className={cx(
          styles[
            isFallbackImage ? 'img-zoom-result-fallback' : 'img-zoom-result'
          ],
          'position-absolute',
          {
            'd-none': !isLensVisible
          }
        )}
        style={{
          backgroundImage: `url(${imageSrc})`,
          backgroundPosition: `-${lensPosition.x * zoom}px -${lensPosition.y * zoom}px`,
          backgroundSize: `${(isFallbackImage ? width : width - 10) * zoom}px ${(height - 32) * zoom}px`
        }}
      />
    </>
  );
};

export default MagnifyImage;
